import React, { useState, useEffect } from 'react';

const DISMISSED_KEY = 'phrenos_hide_install_prompt';

const InstallBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Already dismissed
    if (localStorage.getItem(DISMISSED_KEY) === '1') return;

    // Already installed (running as standalone PWA)
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true;
    if (isStandalone) return;

    const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    setIsIOS(ios);

    if (ios) {
      // iOS: show static instructions
      setVisible(true);
    } else {
      // Android/Chrome: wait for install prompt event
      const handler = (e: Event) => {
        e.preventDefault();
        setDeferredPrompt(e);
        setVisible(true);
      };
      window.addEventListener('beforeinstallprompt', handler);
      return () => window.removeEventListener('beforeinstallprompt', handler);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, '1');
    setVisible(false);
  };

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      dismiss();
    } else {
      setDeferredPrompt(null);
      setVisible(false);
    }
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 70, // above the tab bar
        left: 12,
        right: 12,
        zIndex: 9000,
        backgroundColor: 'var(--color-primary)',
        color: '#fff',
        borderRadius: 14,
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        boxShadow: '0 8px 24px rgba(31,76,64,0.35)',
        fontSize: 13,
      }}
    >
      <span style={{ fontSize: 20, flexShrink: 0 }}>📲</span>

      {isIOS ? (
        <span style={{ flex: 1, lineHeight: 1.4 }}>
          Add Phrenos to your home screen — tap{' '}
          <strong>Share</strong>{' '}
          <span style={{ fontSize: 15 }}>⎙</span>{' '}
          then <strong>"Add to Home Screen"</strong>
        </span>
      ) : (
        <span style={{ flex: 1, lineHeight: 1.4 }}>
          Install Phrenos for a faster, app-like experience
        </span>
      )}

      {!isIOS && deferredPrompt && (
        <button
          onClick={handleInstall}
          style={{
            padding: '6px 14px',
            borderRadius: 999,
            border: '1.5px solid rgba(255,255,255,0.8)',
            background: 'transparent',
            color: '#fff',
            fontWeight: 700,
            fontSize: 13,
            cursor: 'pointer',
            flexShrink: 0,
          }}
        >
          Install
        </button>
      )}

      <button
        onClick={dismiss}
        style={{
          background: 'none',
          border: 'none',
          color: 'rgba(255,255,255,0.7)',
          fontSize: 18,
          cursor: 'pointer',
          padding: 0,
          lineHeight: 1,
          flexShrink: 0,
        }}
        aria-label="Dismiss"
      >
        ✕
      </button>
    </div>
  );
};

export default InstallBanner;
